import { Route, AppId, createPageRoute } from '@lumapps/router';

export const analyticsSettingsRoute: Route = createPageRoute({
    slug: 'analytics/settings',
    appId: AppId.backOffice,
});
